class VolumeDiscountMapper {
  /**
   * Takes a IVolumeDiscountRateApiResponse from Packlink's API and returns a IVolumeDiscountRate.
   *
   * @param response IVolumeDiscountRateApiResponse response from Packlink's API.
   *
   */

  static createRateFromResponse(response) {
    if (!response) {
      return undefined;
    }
    return {
      carrierId: response.carrier_id,
      carrierName: response.carrier_name,
      minShipments: response.min_shipments,
      maxShipments: response.max_shipments
    };
  }

  /**
   * Takes a IVolumeDiscountBandApiResponse from Packlink's API and returns a IVolumeDiscountBand.
   *
   * @param response IVolumeDiscountBandApiResponse response from Packlink's API.
   *
   */

  static createBandFromResponse(response) {
    if (!response) {
      return undefined;
    }
    return {
      minShipments: response.min_shipments,
      maxShipments: response.max_shipments
    };
  }

  /**
   * Creates API payload required for endpoint that creates a volume discount estimate.
   *
   * @param response IVolumeDiscountBand item returned from `getBands()` request.
   *
   */
  static createBandApiPayload(response) {
    return {
      min_shipments: response.minShipments,
      max_shipments: response.maxShipments
    };
  }
}

export { VolumeDiscountMapper };
//# sourceMappingURL=VolumeDiscountMapper.js.map
